class ProductLocallyLocator extends HTMLElement {
  static get observedAttributes() {
    return ['upc'];
  }

  constructor() {
    super();
    this.config = {
      company_name: 'Far Bank',
      button_text: 'Find Locally',
      button_id: 'HTML',
      company_id: '210801',
      n_related_styles: '3',
      show_location_prompt: '1',
      lang: 'en-us',
      n_dealers: '3',
      category: 'specialty',
      no_link: '1',
      link_opens_modal: '1',
    };
    this.scriptId = 'lcly-script-0';
  }

  connectedCallback() {
    this.render();
    const upc = this.getAttribute('upc');
    if (upc) {
      this.config.upc = upc;
      this.loadLocallyScript();
    }
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === 'upc' && oldValue !== newValue) {
      this.reloadScript(newValue);
    }
  }

  render() {
    this.innerHTML = `
      <div
        id="lcly-button-0"
        class="product-locally-product-locator"
        data-switchlive="true"
        data-switchlive-impression="true"
        data-switchlive-impression-id-PL="1"
      >
        <a
          id="lcly-link-0"
          data-switchlive="true"
          data-switchlive-mode="auto"
          data-switchlive-id-PL="6"
          role="button"
          href="https://join.locally.com/for-brands"
          target="_blank"
        >
          ${this.config.button_text}
        </a>
      </div>
    `;
  }

  loadLocallyScript() {
    this.removeLocallyScript();
    const script = document.createElement('script');
    script.id = this.scriptId;
    script.src = this.generateEndpoint();
    document.body.appendChild(script);
  }

  reloadScript(newUpc) {
    this.config.upc = newUpc;
    this.loadLocallyScript();
  }

  removeLocallyScript() {
    const oldScript = document.getElementById(this.scriptId);
    if (oldScript) oldScript.remove();
  }

  generateEndpoint() {
    const query = new URLSearchParams(this.config).toString();
    return `https://far-bank.locally.com/stores/map.js?${query}`;
  }
}

customElements.define('product-locally-locator', ProductLocallyLocator);

// Listen for variant changes (Dawn emits this)
document.addEventListener('variant:change', (event) => {
  const { variant } = event.detail;
  const locator = document.querySelector('product-locally-locator');
  if (locator && variant?.barcode) {
    locator.setAttribute('upc', variant.barcode);
  }
});

// Initial load: map current variant to UPC
document.addEventListener('DOMContentLoaded', () => {
  const locator = document.querySelector('product-locally-locator');
  if (!locator) return;

  const productForm = document.querySelector('form[data-product-form]');
  if (!productForm) return;

  const selectedVariantId = productForm.querySelector('[name="id"]')?.value;
  if (!selectedVariantId) return;

  const variants = JSON.parse(productForm.dataset.variants);
  const variant = variants.find((v) => v.id === selectedVariantId);

  if (variant?.barcode) {
    locator.setAttribute('upc', variant.barcode);
  }
});
